<template>
  <div>
    <identity-verification-form
      :form-model="formModel"
      :person-title="locale.debtorEmployees.theEmployee"
      :persons-only="true"
      :view-mode="loading"
      :manager-social-id-required="false"
      @isIdentityVerified="$emit('isIdentityVerified', $event)"
    ></identity-verification-form>
    <naj-dynamic-form
      :form-model="formModel"
      :form-fields="formFields"
      :view-mode="loading"
    ></naj-dynamic-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('BankruptcyModule');
import IdentityVerificationForm from '../../../identity-verification-form.vue';

export default {
  inject: ['$validator'],
  components: { IdentityVerificationForm },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return { locale: this.local.bankruptcy.requestDetails };
  },
  computed: {
    ...mapState(['countries', 'currencies']),
    formFields() {
      return [
        {
          typeId: this.formFieldType.selectbox,
          name: 'nationality',
          label: this.locale.debtorEmployees.nationality,
          columnSize: 4,
          properties: JSON.stringify({
            validations: { required: true },
            dataSource: this.countries,
            isDimmed: `!(!obj.nationality)`,
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'mobile',
          label: this.locale.debtorEmployees.mobile,
          columnSize: 4,
          properties: JSON.stringify({
            validations: {
              numeric: true,
              phone: true,
              digits: 10,
            },
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'email',
          label: this.locale.debtorEmployees.email,
          columnSize: 4,
          properties: JSON.stringify({
            validations: {
              email: true,
              no_gov_email: true,

            },
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'salaryPerMonth',
          label: this.locale.debtorEmployees.salaryPerMonth,
          columnSize: 6,
          properties: JSON.stringify({
            validations: {
              required: true,
              decimal: 2,
              max_number_length: 20,
            },
          }),
        },
        {
          typeId: this.formFieldType.selectbox,
          name: 'currencyId',
          label: this.locale.debtorEmployees.currency,
          columnSize: 6,
          properties: JSON.stringify({
            validations: { required: true },
            dataSource: this.currencies,
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'duesValue',
          label: this.locale.debtorEmployees.duesValue,
          columnSize: 6,
          properties: JSON.stringify({
            validations: {
              required: true,
              decimal: 2,
              max_number_length: 20,
            },
          }),
        },
        {
          typeId: this.formFieldType.text,
          name: 'duesDescription',
          label: this.locale.debtorEmployees.duesDescription,
          columnSize: 6,
          properties: JSON.stringify({
            validations: {
              required: true,
              max: 200,
            },
          }),
        },
      ];
    },
  },
  mounted() {
    this.getCurrencies();
    this.getCountries();
  },
  methods: { ...mapActions(['getCurrencies', 'getCountries']) },
};
</script>

<style lang="scss" scoped>
</style>
